import { memo } from "react";
import { Steps } from "antd";
import styled from "styled-components";

interface IStep {
  title: string;
}
interface IProps {
  steps: IStep[];
  current: number;
}

export const FormSteps = memo(({ steps, current }: IProps) => {
  return (
    <StyledSection>
      <StyledStep size="default" current={current} items={steps} />
    </StyledSection>
  );
});
const StyledStep = styled(Steps)``;
const StyledSection = styled.section`
  padding: 28px 44px;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 40px;
  max-width: 960px;
`;
